/*
描述：爆料监控
日期：2017-5-11
作者：Bai.Zhiming
 */
"use strict";
angular.module("newsMonitorModule", ["newsMonitorRouterModule", "weiboMonitorModule"]);